/* assets/header-backmarket.js */
(() => {
  const header = document.querySelector("[data-bm-header]");
  if (!header) return;

  const forms = Array.from(header.querySelectorAll("[data-bm-search-form]"));
  if (!forms.length) return;

  const MIN_CHARS = 2;
  const LIMIT = 6;
  const DEBOUNCE_MS = 160;

  const currency =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";

  const money = (cents) => {
    if (typeof cents !== "number") return "";
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      }).format(cents / 100);
    } catch {
      return `${Math.round(cents / 100)}`;
    }
  };

  const escapeHtml = (s) =>
    String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const normalizeImgUrl = (u) => {
    if (!u) return "";
    if (typeof u === "string") return u.startsWith("//") ? `https:${u}` : u;
    if (typeof u === "object") {
      const maybe = u.url || u.src;
      if (typeof maybe === "string") return maybe.startsWith("//") ? `https:${maybe}` : maybe;
    }
    return "";
  };

  const getProductImage = (p) => {
    // Shopify kan returnere lidt forskellige felter afhængigt af tema/API-version
    return (
      normalizeImgUrl(p?.featured_image?.url) ||
      normalizeImgUrl(p?.featured_image) ||
      normalizeImgUrl(p?.image) ||
      normalizeImgUrl(p?.featured_media?.preview_image?.url) ||
      normalizeImgUrl(p?.featured_media?.preview_image?.src) ||
      ""
    );
  };

  const getProductImageAlt = (p) => {
    const alt =
      p?.featured_image?.alt ||
      p?.image?.alt ||
      p?.featured_media?.preview_image?.alt ||
      p?.title ||
      "";
    return String(alt || "");
  };

  const attach = (form) => {
    const input = form.querySelector("[data-bm-search-input]");
    const results = form.querySelector("[data-bm-search-results]");
    if (!input || !results) return;

    // Kun desktop skal have billeder
    const isMobileForm =
      !!form.closest(".bm-mobile-search") ||
      form.classList.contains("bm-search--mobile");

    let timer = null;
    let abort = null;

    const setExpanded = (expanded) => {
      input.setAttribute("aria-expanded", expanded ? "true" : "false");
      results.hidden = !expanded;
    };

    const clearResults = () => {
      results.innerHTML = "";
      setExpanded(false);
    };

    const render = (q, products) => {
      const head = `<div class="bm-sr__head">Produkter</div>`;

      const items = products
        .map((p) => {
          const thumb =
            !isMobileForm && p.image
              ? `<img class="bm-sr__thumb" src="${escapeHtml(
                  p.image
                )}" alt="${escapeHtml(p.imageAlt || p.title || "")}" loading="lazy" decoding="async" />`
              : "";

          return `
            <a class="bm-sr__item" role="option" href="${escapeHtml(p.url)}">
              <span class="bm-sr__left">
                ${thumb}
                <span class="bm-sr__title">${escapeHtml(p.title)}</span>
              </span>
              <span class="bm-sr__price">${escapeHtml(p.price || "")}</span>
            </a>
          `;
        })
        .join("");

      const foot = `
        <div class="bm-sr__foot">
          <a class="bm-sr__all" href="/search?q=${encodeURIComponent(
            q
          )}&type=product&options[prefix]=last">
            Vis alle resultater
          </a>
        </div>
      `;

      results.innerHTML = head + items + foot;
      setExpanded(true);
    };

    const fetchSuggestions = async (q) => {
      const url = new URL("/search/suggest.json", window.location.origin);
      url.searchParams.set("q", q);
      url.searchParams.set("resources[type]", "product");
      url.searchParams.set("resources[limit]", String(LIMIT));
      url.searchParams.set("resources[options][unavailable_products]", "hide");

      try {
        if (abort && typeof abort.abort === "function") abort.abort();
        abort = typeof AbortController !== "undefined" ? new AbortController() : null;
      } catch {
        abort = null;
      }

      const res = await fetch(url.toString(), {
        signal: abort ? abort.signal : undefined,
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });

      if (!res.ok) return [];

      const data = await res.json();
      const prods = data?.resources?.results?.products || [];

      return prods.map((p) => ({
        title: p.title,
        url: p.url || `/search?q=${encodeURIComponent(q)}&type=product&options[prefix]=last`,
        price: typeof p.price === "number" ? money(p.price) : "",
        image: getProductImage(p),
        imageAlt: getProductImageAlt(p),
      }));
    };

    const onInput = () => {
      const q = input.value.trim();
      if (q.length < MIN_CHARS) return clearResults();

      if (timer) clearTimeout(timer);
      timer = setTimeout(async () => {
        try {
          const items = await fetchSuggestions(q);
          if (!items.length) return clearResults();
          render(q, items);
        } catch {
          clearResults();
        }
      }, DEBOUNCE_MS);
    };

    input.addEventListener("input", onInput);
    input.addEventListener("focus", onInput);

    input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") clearResults();
    });

    document.addEventListener("mousedown", (e) => {
      if (!form.contains(e.target)) clearResults();
    });
  };

  forms.forEach(attach);
})();
